import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { AllotmentLetterListModel } from "src/app/model/AllotmentLetterListModel";
import { DocumentVerificationModel } from "src/app/model/DocumentVerificationModel";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { Page } from "src/app/model/Page";
import { DocumentVerificationService } from "src/app/services/document-verification.service";
import { ExportImportService } from "src/app/services/export-import.service";
import { MasterService } from "src/app/services/master.service";
import { OfficialsService } from "src/app/services/officials.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";
import { SurrReqVerificationService } from "src/app/services/surr-req-verification.service";
import { UploadFileModalComponent } from "../upload-file-modal/upload-file-modal.component";
import { ModalController } from "@ionic/angular";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ModalComponent } from "../corrigendum-upload/modal/modal.component";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";

@Component({
  selector: "app-secure-upload-corriegendum",
  templateUrl: "./upload-corriegendum.component.html",
  styleUrls: ["./upload-corriegendum.component.scss"],
})
export class UploadCorriegendumComponent implements OnInit {
  [x: string]: any;
  isLoading: boolean = false;
  lotteryList: {[key: number]: string};
  boardValue:boolean =false;
  lotteryValue:boolean =false;
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  boards: {[key: number]: string};
  board:any;
  lottery:any;
  startDate:any;
  endDate:any;
  schemeList: {[key: number]: string};
  scheme:any;
  selectedElement: PaymentSettlementModel[] = [];
  selectedApplicationNumbers: string[] = [];
  count: string;

  page: Page<DocumentVerificationModel>;
  dataSource: MatTableDataSource<DocumentVerificationModel> =
    new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "checkbox",
    "id",
    "applicationNo",
    "applicantName",
    "scheme",
    "appdrawStatus",
    "action"
  ];
  pageSizeOptions: number[] = [10, 25, 100, 200, 400];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService, 
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe, 
    private masterService: MasterService,
    private documentVerificationService: DocumentVerificationService,
    private surrReqVerificationService: SurrReqVerificationService,
    private modalCtrl: ModalController,
    private uploadCorrigendumService: ViewApplicationService,

  ) {}

  // ngOnInit(): void {
  //   this.loadData();


  //   this.startDateControl = new FormControl();
  //   this.startDateControl.valueChanges.subscribe((startDate) => {
  //     const today = new Date();
  //     today.setHours(0, 0, 0, 0);
      
  //     if (new Date(startDate) <= today) {
  //       this.startDateControl.setErrors(null);
  //     } else {
  //       this.startDateControl.setErrors({ futureDate: true });
  //     }
  //   });

  //   this.endDateControl = new FormControl();
  //   this.endDateControl.valueChanges.subscribe((endDate) => {
  //     if (endDate > new Date()) {
  //       this.endDateControl.setErrors({ futureDate: true });
  //     } else {
  //       this.endDateControl.setErrors(null);
  //     }
  //   });


  //   this.form = new FormGroup({
  //     lottery: new FormControl(null, Validators.required),
  //     scheme: new FormControl(null, Validators.required),
  //   });

   
  // }

  ngOnInit(): void {
    this.loadData();
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-view-application-filterText")
        , [Validators.required, Validators.minLength(3)])
    });  
       this.filterForm.controls['filterText'].setValue(null);
  }

  
  validateEndDate() {
    return new Date(this.form.value.endDate) < new Date(this.form.value.startDate)
    ? true
    : false;
  }
  
  async openModal() {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      cssClass: "custom-modal",
    });
    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      if (data.corrigendumName !== null && data.corrigendumName !== "") {
        if(this.selectedApplicationNumbers !== null && this.selectedApplicationNumbers.length !== 0){
          console.log(this.selectedApplicationNumbers);
          this.saveSelectedCorrigendum(data, this.selectedApplicationNumbers);

        }else{
          console.log("schemewise called");
          this.saveCorrigendum(data);
      }
      } else {
        this.masterService.errorToast("Please Fill Correspondence Name");
      }
    }
  }
  async openModal1(applicationNo: string) {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      cssClass: "custom-modal",
      componentProps: {
        applicationNo: applicationNo  
      }
    });
    await modal.present();
  
    const { data, role } = await modal.onWillDismiss();
  
    if (role === "submit") {
      if (data.corrigendumName !== null && data.corrigendumName !== "") {
        this.saveCorrigendumForApplication(data, applicationNo);
      } else {
        this.masterService.errorToast("Please Fill Correspondence Name");
      }
    }
  }
  
  saveCorrigendum(data) {
    console.log(this.lottery);
    console.log(data.corrigendumName);
    console.log(data.corrigendumFileName);

    const corrigendumName = data.corrigendumName;
    const corrigendumFileName = data.corrigendumFileName;

    if (this.lottery && this.scheme) {
        // Call backend API with both lottery and scheme
        this.masterService
            .addCorrigendumForLotteryAndScheme(
                this.lottery,
                this.scheme,
                corrigendumName,
                corrigendumFileName
            )
            .subscribe(
                (resp) => {
                    if (resp.status === "SUCCESS") {
                        this.successToast("Correspondence saved successfully.");
                        this.getCorrigendumDetails(this.registrationId);
                    } else {
                        this.errorToast(resp.errorMessage);
                    }
                },
                (error) => {
                    this.errorToast(error?.error?.message || error?.error?.errorMessage);
                }
            );
    } else if (this.lottery) {
        // Call backend API with only lottery
        this.masterService
            .addcorigendumForLottery(
                this.lottery,
                corrigendumName,
                corrigendumFileName
            )
            .subscribe(
                (resp) => {
                    if (resp.status === "SUCCESS") {
                        this.successToast("Correspondence saved successfully.");
                        this.getCorrigendumDetails(this.registrationId);
                    } else {
                        this.errorToast(resp.errorMessage);
                    }
                },
                (error) => {
                    this.errorToast(error?.error?.message || error?.error?.errorMessage);
                }
            );
    } else {
        // If neither lottery nor scheme is selected, show an error message
        this.masterService.errorToast("Please select at least the lottery.");
    }
}
saveCorrigendumForApplication(data, applicationNo: string) {
  console.log(this.lottery);
  console.log(data.corrigendumName);
  console.log(data.corrigendumFileName);
  console.log(this.applicationNo);

  const corrigendumName = data.corrigendumName;
  const corrigendumFileName = data.corrigendumFileName;

  if (this.lottery && this.scheme) {
      // Call backend API with both lottery and scheme
      this.masterService
          .addCorrigendumForApplication(
              this.lottery,
              this.scheme,
              applicationNo,
              corrigendumName,
              corrigendumFileName
          )
          .subscribe(
              (resp) => {
                  if (resp.status === "SUCCESS") {
                      this.successToast("Correspondence saved successfully.");
                      this.getCorrigendumDetails(this.registrationId);
                  } else {
                      this.errorToast(resp.errorMessage);
                  }
              },
              (error) => {
                  this.errorToast(error?.error?.message || error?.error?.errorMessage);
              }
          );
  } else {
      // If neither lottery nor scheme is selected, show an error message
      this.masterService.errorToast("Please select at least the lottery.");
  }
}

saveSelectedCorrigendum(data, selectedApplicationNumbers: string[]) {
  console.log(this.lottery);
  console.log(data.corrigendumName);
  console.log(data.corrigendumFileName);
  console.log(selectedApplicationNumbers); // Log selected application numbers

  const corrigendumName = data.corrigendumName;
  const corrigendumFileName = data.corrigendumFileName;

  if (this.lottery && this.scheme) {
      this.masterService
          .addCorrigendumForSelectedApplication(
              this.lottery,
              this.scheme,
              selectedApplicationNumbers,
              corrigendumName,
              corrigendumFileName
          )
          .subscribe(
              (resp) => {
                  if (resp.status === "SUCCESS") {
                      this.successToast("Correspondence saved successfully.");
                      this.getCorrigendumDetails(this.registrationId);
                  } else {
                      this.errorToast(resp.errorMessage);
                  }
              },
              (error) => {
                  this.errorToast(error?.error?.message || error?.error?.errorMessage);
              }
          );
  } else {
      // If neither lottery nor scheme is selected, show an error message
      this.masterService.errorToast("Please select at least the lottery.");
  }
}
  loadData() {

    this.publishLetterService
    .publishDocumentsInitForm()
    .subscribe((data: any) => {
       this.isLoading = false;
        this.lotteryList = data.lotteryList;
    }, error => {
      this.isLoading = false;
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    });
  
  }

 
  refresh() {
    this.loadData();
  }
  
  
  async successToast(p0: string) {
    await this._snackBar.open(
        " Correspondence saved successfully",
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}


resetFilter() {
  
  window.location.reload();
}
resetFilter1() {
  this.filterForm.get('filterText').setValue(null); // Reset the filter text value to null
  this.findschemeapplicantList();
}


onLotteryChange(lotteryId:any){
  this.lottery=lotteryId,
  this.scheme = null; // Reset the scheme when lottery changes
  this.auditTrailService.getSchemeNameService(lotteryId)
  .subscribe((data:LotteryFormResponse) => {
    this.schemeList=data.schemeList;
this.lotteryValue=!!lotteryId
   
  });
}
onSchemeChange(schemeId: any) {
  this.selectedApplicationNumbers = []; 
  this.count = "0"; 
  this.scheme=schemeId,
  this.findschemeapplicantList();
}

findschemeapplicantList() {
  this.showSpinner = true;

  if (this.lottery !== null) {
    this.masterService.getSchemeApplicationFilterList(
      this.lottery,
      this.scheme,
      this.currentPage,
      this.pageSize,
      this.filterForm.value.filterText
    ).subscribe(
      (page: any) => {
        this.page = page;

        if (page.content && page.content.length !== 0) {
          // Update dataSource with filtered data
          const newData = page.content.map((item) => {
            return { ...item, isSelected: this.selectedApplicationNumbers.includes(item.applicationNo) };
          });
          this.dataSource = new MatTableDataSource(newData);
        } else {
          this.dataSource = new MatTableDataSource([]);
        }

        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.totalElements;
        });

        this.showSpinner = false;
        this.loaded = true;
      },
      (error) => {
        console.log(error);
        this.loaded = false;
        this.showSpinner = false;
      }
    );
  } else {
    this.documentVerificationService.errorToast("Please select Lottery");
  }
}



pageChanged(event: PageEvent) {
  console.log({ event });
  console.log(event.pageSize);
  this.pageSize = event.pageSize;
  this.currentPage = event.pageIndex;
//  this.loadData();
this.findschemeapplicantList();

}
async uploadLotteryCorrigendum() {
  this.isLoading =false;
  console.log(this.lottery);
  console.log("hiiii");

  this.fileType = "CORRIGENDUM_LETTER";
  const modal = await this.modalCtrl.create({
      component: UploadFileModalComponent,
      componentProps: {
          modalHeader: "CORRIGENDUM Letter File Upload",
       //   base64: this.data.agreementLtrFile != null? this.data.agreementLtrFile:null,
          base64: this.base64 != null ? this.base64 : null,
          fileType: "CORRIGENDUM_LETTER",
      }
  });
  modal.present();

  const { data } = await modal.onWillDismiss();
  
  if (data != null) {
      this.onSubmit(data, this.fileType);
      console.log(this.lottery);
      console.log(this.fileType);

  }
}

onCheckboxChange(element: any) {
  const index = this.selectedApplicationNumbers.indexOf(element.applicationNo);
  if (element.isSelected && index === -1) {
    // If checkbox is checked and application number is not in the array, add it
    this.selectedApplicationNumbers.push(element.applicationNo);
  } else if (!element.isSelected && index !== -1) {
    // If checkbox is unchecked and application number is in the array, remove it
    this.selectedApplicationNumbers.splice(index, 1);
  }
  this.count = this.selectedApplicationNumbers.length.toString();
}
isApplicationSelected(applicationNo: string): boolean {
  return this.selectedApplicationNumbers.includes(applicationNo);
}
onSearch() {
  if (this.filterForm.valid) {
    this.page = null;
    this.dataSource = null;
    this.pageSize = 0;
    this.currentPage = 0;
    this.filterForm.value.filterText;

    this.onLoad();
    this.updateCheckboxStateAfterSearch();

  } else {
    this._snackBar.open("Application Number is Required ", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
    this.isSearchDisabled = false;
  }
}
onLoad() {
  this.loaded = false;
  this.masterService.getSchemeApplicationFilterList(
    this.lottery,
    this.scheme,
    this.currentPage,
    this.pageSize,
    this.filterForm.value.filterText
  ).subscribe(
    (page: any) => {
      this.page = page;

      if (page.content && page.content.length !== 0) {
        // Update dataSource with filtered data
        const newData = page.content.map((item) => {
          return { ...item, isSelected: this.isApplicationSelected(item.applicationNo) };
        });
        this.dataSource = new MatTableDataSource(newData);
      } else {
        this.dataSource = new MatTableDataSource([]);
        // Display Snackbar message when application numbers are not found
        this._snackBar.open("Application Number Not Found ", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
      }

      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });

      this.isSearchDisabled = false;
      this.loaded = true;
    },
    (error) => {
      console.log(error);
      this.loaded = false;
      this.isSearchDisabled = false;
    }
  );
}

isAnyCheckboxSelected(): boolean {
  return this.selectedApplicationNumbers.length > 0;
}






// onLoad() {
//   this.loaded = false;
//   this.paymentSettlementService

//     .getPaymentDefaulterList(
//       this.currentPage,
//       this.pageSize,
//       this.filterForm.value.filterText
//     )
//     .subscribe(
//       (page: any) => {
//         this.page = page;

//         if (page.content && page.content.length !== 0) {
//           this.dataSource = new MatTableDataSource(page.content);
//         } else {
//           this._snackBar.open("Application Number Not Found ", "Close", {
//             horizontalPosition: "right",
//             verticalPosition: "top",
//             panelClass: "warning-toast",
//             duration: 3 * 1000,
//           });
//         }
//         setTimeout(() => {
//           this.paginator.pageIndex = this.currentPage;
//           this.paginator.length = page.totalElements;
//         });
//         this.isSearchDisabled = false;
//         this.loaded = true;
//       },
//       (error) => {
//         console.log(error);
//         this.loaded = false;
//         this.isSearchDisabled = false;
//       }
//     );
//   // this.loaded = true;
// }
}

